import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MnpEventStatusEnum } from '../../../service/movement-no-purchase.service';

export interface MnpDetailsPopupData {
  locationName: string;
  branchName: string;
  time: string;
  cameraName: string;
  rhombusLink: string;
  comments: string;
  status: MnpEventStatusEnum;
  id: string;
}

@Component({
  selector: 'app-movement-no-purchase-details-popup',
  templateUrl: './movement-no-purchase-details-popup.component.html',
  styleUrls: ['./movement-no-purchase-details-popup.component.scss'],
  standalone: false,
})
export class MovementNoPurchaseDetailsPopupComponent {
  data: MnpDetailsPopupData;

  loadingData = false;

  constructor() {
    const data = inject<MnpDetailsPopupData>(MAT_DIALOG_DATA);

    this.data = data;
  }
}
